import { render, staticRenderFns } from "./OrganizersList.vue?vue&type=template&id=e7fd404a"
import script from "./OrganizersList.vue?vue&type=script&lang=js"
export * from "./OrganizersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports